var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#BC172F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9474 28.4329C18.9474 28.1219 19.0086 27.8139 19.1277 27.5265C19.2467 27.2392 19.4212 26.9781 19.6411 26.7582C19.861 26.5382 20.1221 26.3638 20.4095 26.2448C20.6968 26.1257 21.0048 26.0645 21.3158 26.0645C21.6268 26.0645 21.9348 26.1257 22.2222 26.2448C22.5095 26.3638 22.7706 26.5382 22.9905 26.7582C23.2105 26.9781 23.3849 27.2392 23.5039 27.5265C23.623 27.8139 23.6842 28.1219 23.6842 28.4329C23.6842 29.061 23.4347 29.6635 22.9905 30.1076C22.5464 30.5518 21.944 30.8013 21.3158 30.8013C20.6877 30.8013 20.0852 30.5518 19.6411 30.1076C19.1969 29.6635 18.9474 29.061 18.9474 28.4329ZM19.1795 14.2105C19.148 13.9117 19.1796 13.6096 19.2723 13.3239C19.3651 13.0381 19.5169 12.775 19.7179 12.5517C19.9189 12.3283 20.1646 12.1497 20.439 12.0275C20.7135 11.9053 21.0106 11.8421 21.3111 11.8421C21.6115 11.8421 21.9086 11.9053 22.1831 12.0275C22.4576 12.1497 22.7033 12.3283 22.9043 12.5517C23.1053 12.775 23.2571 13.0381 23.3498 13.3239C23.4426 13.6096 23.4742 13.9117 23.4427 14.2105L22.6137 22.5166C22.58 22.8386 22.4283 23.1367 22.1877 23.3534C21.9471 23.5701 21.6348 23.6901 21.3111 23.6901C20.9873 23.6901 20.675 23.5701 20.4344 23.3534C20.1939 23.1367 20.0421 22.8386 20.0084 22.5166L19.1795 14.2105Z",
    fill: "#BC172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f54bcec47d16efc26936450832966b8c.svg";
export { ForwardRef as ReactComponent };